module.exports = __webpack_public_path__ + "static/media/edit-secundary.2927f8de.svg";